module.exports = __webpack_public_path__ + "static/media/checklist.9f822825.jpg";